// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","563":"cb355538"}[chunkId] || chunkId) + "-" + {"108":"296a6fe58e678c36c5e9","293":"9a8782f71273e0e14c79","452":"c0ff3ab48c1cc3cab85a","563":"00be7bb9c360c07c662d"}[chunkId] + ".js";
};